import React from 'react'
import { ValidatorComponent } from 'react-form-validator-core'

class InputField extends ValidatorComponent {
  errorStyles = {
    color: '#f25961',
    fontSize: '80%',
    fontWeight: 600,
  }

  errorText = () =>
    this.state.isValid ? null : (
      <div style={this.errorStyles}>{this.getErrorMessage()}</div>
    )
  
  iconRender = () => {
    const { icon } = this.props
    if (icon === null) return null
    if (icon && icon.search('text-') >= 0) {
      return (
        <div className='input-group-append'>
          <span className='input-group-text font-bold'>{icon.replace('text-', '')}</span>
        </div>
      )
    }

    return (
      <div className='input-group-append'>
        <span className='input-group-text'>
          <i className={'fas fa-' + (icon || 'font')}></i>
        </span>
      </div>
    )
  }

  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      validatorListener,
      withRequiredValidator,
      icon,
      value,
      ...rest
    } = this.props

    if (!rest.className) rest.className = 'form-control'
    if (!this.state.isValid) rest.className += ' input_error'

    return (
      <React.Fragment>
        <div className='input-group'>
          <input {...rest} value={value || ''} style={{ textTransform: rest.capitalize ? 'capitalize' : 'none' }} />
          {this.iconRender()}
        </div>
        {this.errorText()}
      </React.Fragment>
    )
  }
}

export default InputField
